/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  MODE_SHAPE_METHOD,
  MODE_SHAPE_UPLOAD,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import { selectHasModeShapeData, selectIsModeShapeMatch } from '#selectors/entities/models.js';
import StructuralPropertiesSection from './StructuralPropertiesSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId, form } = ownProps;
  const { selectFormValues } = modelTypesByForm[form];

  const { [MODE_SHAPE_METHOD]: method, [MODE_SHAPE_UPLOAD]: upload } = selectFormValues(
    state,
    MODE_SHAPE_METHOD,
    MODE_SHAPE_UPLOAD
  );

  const isModeShapeMatch = selectIsModeShapeMatch(state, { modelId, method, upload });
  const hasModeShapeData = selectHasModeShapeData(state, { modelId });

  return {
    showModeShapeDetails: isModeShapeMatch && hasModeShapeData,
  };
};

export default connect(mapStateToProps)(StructuralPropertiesSection);
